import React, { useEffect, useState } from "react";

import { FaPlus, FaFilter, FaTrash, FaEdit, FaUsers } from "react-icons/fa";

import AppPagination from "../components/AppPagination";

import MeetingModal from "../components/Modals/MeetingModal";

import DeleteModal from "../components/Modals/DeleteModal";

const Meeting = () => {
  // Modal States
  const [showMeetingModal, setShowMeetingModal] = useState(false);

  const [editData, setEditData] = useState(null);

  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [deleteId, setDeleteId] = useState(null);

  // Filter
  const [showFilter, setShowFilter] = useState(false);

  // Loading
  const [loading, setLoading] = useState(true);
    useEffect(() => {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }, []);
  

  // Meeting Data
  const meetingData = [
    {
      id: 1,
      title: "Project Discussion",
      date: "2026-05-18",
      time: "11:00 AM",
      host: "Amit Sharma",
      members: 5,
      mode: "Online",
      status: "Upcoming",
    },

    {
      id: 2,
      title: "Client Meeting",
      date: "2026-05-20",
      time: "02:30 PM",
      host: "Rahul Verma",
      members: 3,
      mode: "Offline",
      status: "Completed",
    },

    {
      id: 3,
      title: "Sales Review",
      date: "2026-05-22",
      time: "04:00 PM",
      host: "Sonia Mehta",
      members: 7,
      mode: "Online",
      status: "Cancelled",
    },
  ];

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 5;

  const indexOfLastItem = currentPage * itemsPerPage;

  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const currentItems = meetingData.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(meetingData.length / itemsPerPage);

  // Delete
  const handleDelete = () => {
    console.log(deleteId);

    setShowDeleteModal(false);
  };

  return (
    <div className="lead-page">
      {/* Header */}
      <div className="lead-header">
        <div>
          <h2 className="mb-1">Meeting</h2>
        </div>

        <button
          className="btn btn-primary"
          onClick={() => {
            setEditData(null);
            setShowMeetingModal(true);
          }}
        >
          <FaPlus className="me-1" />
          Add Meeting
        </button>
      </div>

      {/* Table Card */}
      <div className="card mb-4 card-light">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h5 className="card-title mb-0">All Meetings</h5>

          <div className="d-flex gap-2 align-items-center">
            {showFilter && (
              <input
                type="text"
                className="form-control"
                placeholder="Search Meeting"
              />
            )}

            <button
              className="btn btn-dark"
              onClick={() => setShowFilter(!showFilter)}
            >
              <FaFilter className="me-1" />
              Filter
            </button>
          </div>
        </div>

        <div className="card-body">
          <div className="table-outer border">
            <div className="table-responsive">
              <table className="table m-0 align-middle">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Meeting</th>
                    <th>Date</th>
                    <th>Time</th>
                    <th>Host</th>
                    <th>Members</th>
                    <th>Mode</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>

                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="9" className="text-center py-4">
                        Loading...
                      </td>
                    </tr>
                  ) : currentItems.length > 0 ? (
                    currentItems.map((item) => (
                      <tr key={item.id}>
                        <td>#{item.id}</td>

                        <td>{item.title}</td>

                        <td>{item.date}</td>

                        <td>{item.time}</td>

                        <td>{item.host}</td>

                        <td>
                          <span className="badge bg-info">
                            {item.members} Members
                          </span>
                        </td>

                        <td>
                          <span
                            className={`badge ${
                              item.mode === "Online"
                                ? "border text-success border-success"
                                : "border text-dark border-secondary"
                            }`}
                          >
                            {item.mode}
                          </span>
                        </td>

                        <td>
                          <span
                            className={`badge ${
                              item.status === "Pending"
                                ? "bg-warning"
                                : item.status === "Completed"
                                  ? "bg-success"
                                  : "bg-danger"
                            }`}
                          >
                            {item.status}
                          </span>
                        </td>

                        <td>
                          <div className="d-flex gap-2">
                            {/* Edit */}
                            <button
                              className="btn btn-sm btn-info custum_edit text-white"
                              onClick={() => {
                                setEditData(item);

                                setShowMeetingModal(true);
                              }}
                            >
                              <FaEdit />
                            </button>

                            {/* Delete */}
                            <button
                              className="btn btn-sm btn-info custum_danger"
                              onClick={() => {
                                setDeleteId(item.id);

                                setShowDeleteModal(true);
                              }}
                            >
                              <FaTrash />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9" className="text-center py-4">
                        No Data Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Pagination */}
          <div className="row mt-2 p-2">
            <div className="col-md-12">
              <AppPagination
                currentPage={currentPage}
                totalPages={totalPages}
                totalItems={meetingData.length}
                itemsPerPage={itemsPerPage}
                onPageChange={setCurrentPage}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Add/Edit Modal */}
      <MeetingModal
        show={showMeetingModal}
        setShow={setShowMeetingModal}
        editData={editData}
      />

      {/* Delete Modal */}
      <DeleteModal
        show={showDeleteModal}
        setShow={setShowDeleteModal}
        onConfirm={handleDelete}
        title="Delete Meeting?"
        message="Are you sure you want to delete this meeting?"
      />
    </div>
  );
};

export default Meeting;
